import React from 'react';
import { observer } from 'mobx-react';
import {
  IconType, Icon,
} from '@routific/hive';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../store/mst';
import ActionButton, { CommonActionTypes } from '../../../shared/ActionButton';
import { RouteProps } from '../../../../store/mst/utils/getRoutesProps';

interface Props {
  routeProps: RouteProps;
  type?: 'button' | 'menu';
}

const EditButton: React.FC<Props> = ({
  routeProps, type,
}) => {
  const store = useStore();
  const { route } = store;
  const { t } = useTranslation('components');

  const { ids, isLocked, disabled, finished } = routeProps;

  const id = ids[0];

  const getTooltipText = () => {
    // Editing stays open once published and once started: what is still actionable narrows field by
    // field inside the modal rather than closing the affordance. Only a finished route has nothing left.
    if (finished) {
      return t('publish.tooltip.editFinished');
    }

    if (isLocked) {
      return t('components:publish.tooltip.routeLocked');
    }

    if (disabled) {
      return t('moreActionsDropdown.tooltip.noPermission');
    }
    return undefined;
  };

  return (
    <>
      <ActionButton
        name={CommonActionTypes.EDIT}
        tooltipProps={{
          title: getTooltipText(),
        }}
        type={type}
        disabled={disabled || finished}
        menuItemProps={{
          onClick: () => route.openRouteFormModal(id),
          icon: <Icon icon={IconType.Edit} />,
        }}
        menuItemText={t('moreActionsButton.route.button.edit.text')}
        buttonProps={{
          icon: IconType.Edit,
          onClick: () => route.openRouteFormModal(id),
        }}
      />
    </>
  );
};

export default observer(EditButton);
